import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricPart7Config, GeneralProceduresCricMainConfig } from "../GeneralProceduresCricMain";

export default class GeneralProceduresCricPart7 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresCricPart7Config {
		return this.scenarioConfig.part7Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.scenario.debriefLog('Insert ETTube until cuff is 2cm past skin.');
		this.step1ShowEttOptionsUI();
	}

	public step1ShowEttOptionsUI() {
		const context = this;
		context.scenario.uiWrapper.displayEttOptionsUI({
			OnNextClicked: (selectedDepth: number) => {
				var isCorrect = selectedDepth === 2;

				if(!isCorrect) {
					context.scenario.displayMessage("This is an incorrect selection. Please try again", () => {
						context.step1ShowEttOptionsUI();
					})
					return;
				}
				if(context.config.onEtOptionsUIClosed) {
					context.config.onEtOptionsUIClosed(selectedDepth);
				}
				context.step2ShowInsertionWait();
			}
		})
	}

	public step2ShowInsertionWait() {
		const context = this;
		context.scenario.addScore(context.scenario.cricEttPoints);
		var onDoneWithPopup = context._scenario.doSomething('Inserting ET Tube...');
		context.playVideoChapter(context.config.etTubeVideoChapter(), () => {
			
		});

		setTimeout(() => {
			onDoneWithPopup();
			context.onDone();
		}, constants.doSomethingTimeout);
	}
}